<template>
  <div ref="hotelList" class="hotel-list" data-test="hotel-list">
    <div class="hotel-list__cards">
      <TransitionGroup name="fade">
        <template v-if="currentDevice.isMobile">
          <div class="swiper ib-swiper--template-default js-swiper-hotel-card">
            <div class="swiper-wrapper">
              <HotelCard
                v-for="hotel in hotelsInfoStore.hotelsPaginated"
                :key="hotel.id"
                :hotel="hotel"
                class="swiper-slide"
              />
            </div>
          </div>
        </template>
        <template v-else>
          <HotelCard v-for="hotel in hotelsInfoStore.hotelsPaginated" :key="hotel.id" :hotel="hotel" />
        </template>
      </TransitionGroup>
    </div>

    <ListPagination />
  </div>
</template>

<script setup>
import 'swiper/css/navigation'

import Swiper from 'swiper'
import { onMounted, ref } from 'vue'

import { currentDevice } from '../../../../../core/utils/currentDevice'
import { useHotelsInfoStore } from '../../../blocks/HotelsInfo/store/hotels_info'
import { loadStyles } from '../../../mixins/LoadStyles/LoadStyles'
import HotelCard from '../HotelCard/HotelCard'
import ListPagination from '../ListPagination/ListPagination'

/**
 * Props
 */
const props = defineProps({
  offerInfo: {
    type: Object,
    default: () => ({}),
  },
  fastbookingDates: {
    type: Object,
    default: () => ({}),
  },
})

/**
 * Refs
 */
const hotelList = ref(null)

function initMobileCardsSwiper() {
  const block = hotelList.value
  const swiperDefault = block.querySelector('.js-swiper-hotel-card')

  if (!swiperDefault) return

  new Swiper(swiperDefault, {
    slidesPerView: 1.2,
    spaceBetween: 9,
    loop: false,
    lazyPreloadPrevNext: 1,
  })
}
/**
 * Lifecycle
 */
onMounted(() => {
  IB.currencyForm.forceUpdate()
  initMobileCardsSwiper()
})

/**
 * Styles
 */
const COMPONENT_NAME = 'HotelList'
loadStyles({ name: COMPONENT_NAME, folder: 'components/HotelsInfo' })

/**
 * Store
 */
const hotelsInfoStore = useHotelsInfoStore()
</script>
